export const proposalConstants = {
  PROPOSALS_SUCCESS: 'PROPOSALS_SUCCESS',
  PROPOSALS_FAILURE: 'PROPOSALS_FAILURE',
};
